module.exports = __webpack_public_path__ + "Flag-780.db6ade90bba107a23f03986d6c2ed194.svg";